/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.crm.object.user.views.rpc.CrmObjectUserViewsRpc
 */

export const logCrmObjectUserViewRpc = {
  serviceName: 'com.hubspot.crm.object.user.views.rpc.CrmObjectUserViewsRpc',
  rpcName: 'logCrmObjectUserView',
  auth: 'app',
  fingerprint: 'pxASyJLf1AFehK0oLJRfSSKpRK42Dk6B',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRecentlyViewedObjectsForUserRpc = {
  serviceName: 'com.hubspot.crm.object.user.views.rpc.CrmObjectUserViewsRpc',
  rpcName: 'getRecentlyViewedObjectsForUser',
  auth: 'app',
  fingerprint: 'PFAMBEv-0bPiAdMK4ypjMyKpRK42Dk6B',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserRecentlyViewedObjectsRpc = {
  serviceName: 'com.hubspot.crm.object.user.views.rpc.CrmObjectUserViewsRpc',
  rpcName: 'getUserRecentlyViewedObjects',
  auth: 'app',
  fingerprint: 'PFAMBEv-0bPiAdMK4ypjMyKpRK42Dk6B',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserRecentViewsForObjectRpc = {
  serviceName: 'com.hubspot.crm.object.user.views.rpc.CrmObjectUserViewsRpc',
  rpcName: 'getUserRecentViewsForObject',
  auth: 'app',
  fingerprint: 'YB4hAgRa3gx0cstrCO88wyKpRK42Dk6B',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};